import { render, staticRenderFns } from "./BeneficialOwnersView.vue?vue&type=template&id=266ac707&scoped=true&"
import script from "./BeneficialOwnersView.vue?vue&type=script&lang=js&"
export * from "./BeneficialOwnersView.vue?vue&type=script&lang=js&"
import style0 from "./BeneficialOwnersView.vue?vue&type=style&index=0&id=266ac707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ac707",
  null
  
)

export default component.exports